import { useEffect, useState } from 'react'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'
import {
  AddressContainer,
  ImageContainer,
  InnerContainer,
  LocationSkeletonLine,
  PhoneNoWrap,
} from './styles'
import { ReactComponent as LocationImg } from 'assets/TimeLocation/locationNew.svg'
import { IconFilled } from 'components/IconsContainers/styled'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { handleLocalStorage } from 'featureSliced/shared/hooks/handleLocalStorage'
import { pickupLocationParts } from './formatPickupLocation'

const isClickCollect = process.env.REACT_APP_IS_CLIC === '1'

// A load that resolves inside this window shows no placeholder at all — only
// a genuinely slow first visit (the case this banner exists for) sees it.
const PLACEHOLDER_DELAY_MS = 300

export const Location = () => {
  const t = useTranslations()
  const color = useMySelector((state) => state.app.interfaceStyles.FontColor)
  const restaurants = useMySelector((state) => state.restaurants)
  const restaurantsSettled = useMySelector(
    (state) => state.restaurantsStatus.settled
  )
  // the same value the sidebar shows — restaurant-manager's Address → Phone
  const companyPhone = useMySelector((state) => state.app.companyData.Phone)

  const dataEnc = handleLocalStorage('dataEnc')
  const restaurant = restaurants?.find((rest) => rest?.dataEnc === dataEnc)

  const { place, phone } = pickupLocationParts({
    title: restaurant?.title,
    address: restaurant?.address,
    phone: isClickCollect ? companyPhone : null,
  })

  // Once settled, whatever `place`/`phone` compute to is final — a genuinely
  // empty result (no match, no branches) renders as it always did, it just
  // never shows the placeholder.
  const isWaitingForRestaurant = !restaurant && !restaurantsSettled
  const [showPlaceholder, setShowPlaceholder] = useState(false)

  useEffect(() => {
    if (!isWaitingForRestaurant) {
      setShowPlaceholder(false)
      return
    }
    const timer = setTimeout(
      () => setShowPlaceholder(true),
      PLACEHOLDER_DELAY_MS
    )
    return () => clearTimeout(timer)
  }, [isWaitingForRestaurant])

  return (
    <InnerContainer>
      <ImageContainer>
        <IconFilled color={color}>
          <LocationImg />
        </IconFilled>
      </ImageContainer>
      <AddressContainer>
        <p>{t('clickCollect.pickUpLocation')}:</p>
        {isWaitingForRestaurant && showPlaceholder ? (
          <LocationSkeletonLine>
            <Skeleton width="80%" />
            <Skeleton width="45%" />
          </LocationSkeletonLine>
        ) : (
          <p>
            {place}
            {/* the separator travels with the number: a phone that does not fit
                beside the address moves to the next line whole (QRM-649) */}
            {place && phone ? ' ' : ''}
            {phone && <PhoneNoWrap>{place ? `· ${phone}` : phone}</PhoneNoWrap>}
          </p>
        )}
      </AddressContainer>
    </InnerContainer>
  )
}
